export default "__VITE_ASSET__17pk1yHq__"